import {PlainDtoModel} from '../../../../../common/entity/dto/plain/plainDto.model';
import {UserSummary} from '../../../../../account/modules/user/api/entity/userSummary.model';

export class DiscussionParticipantModel implements PlainDtoModel {

    user: UserSummary;
    unreadMessage: boolean;
}
